<template>
  <div class="six">

    <!-- Hero 区域 -->
    <div class="about">
      <div class="hero-text-container">
        <h1 class="">越璋文化 · 品牌故事</h1>
        <p class="">我们叫《越璋》，始于一个名字，也始于一个信念。</p>
        <div class="desc">《越》是我们的态度——不断超越，从未止步。</div>
        <div class="desc">《璋》是璞玉，是未经雕琢却内含光华的美石，一如和氏璧在遇见识</div>
        <div class="desc">者之前——价值早已存在 ，只待被发现、被雕琢、被赋予光芒。</div>
      </div>
      <div class="scroll-down-arrow"></div>
    </div>
    <div class="yz-story">
      <div class="yz-story-container">
        <!-- 标题部分 -->
        <div class="yz-story-header">
          <h1 class="title">越璋故事</h1>
          <p class="subtitle">越璋，是璞玉，也是雕玉之手</p>
        </div>

        <!-- 内容模块 -->
        <div class="story-section">
          <div class="section-header">
            <h2 class="section-title">我们相信什么？</h2>
          </div>
          <div class="section-content">
            <p>我们相信：一切生意的本质，都是流量的经营。而一切流量的本质，都是人心的触达。</p>
            <p>品牌不缺产品，不缺故事，甚至不缺预算。</p>
            <p>缺的是：如何让对的人，在对的场景，听见对的声音。</p>
          </div>
        </div>

        <div class="story-section">
          <div class="section-header">
            <h2 class="section-title">我们做什么？</h2>
          </div>
          <div class="section-content">
            <p>我们不做单纯的“广告投放”，我们做内容的发动机、流量的连接器、数据的雕刻师。</p>
            <p>我们用内容与达人，在小红书埋下真实的种子；我们用CID、UDS、聚光、短信、GEO，让每一分钱都流向可追踪的转化。</p>
            <p>我们用私域与社群，把流量沉淀为信任；我们用RPA与AI，把重复的事情交给机器，把创意的事留给人。</p>
            <p>我们不做“一次性爆款”，我们搭建可持续的流量生态。</p>
          </div>
        </div>

        <div class="story-section">
          <div class="section-header">
            <h2 class="section-title">我们帮助谁？</h2>
          </div>
          <div class="section-content">
            <p>从母婴到美妆，从保健品到宠物，从电器到珠宝——六年来，我们与<span class="highlight">品牌、平台、TP</span>并肩作战，累计实现营销增量<span
                class="highlight">9亿+</span>。</p>
            <p>我们帮蓝河奶粉在18天冲刺到2600万GMV，帮秋霞童装把套装客单价提升44%，帮Swisse、Movefree在大促期间补上千万销量缺口，帮宠物新品牌22天从0做到破百万营收，新客成本仅为行业的1/3。
            </p>
            <p>我们不做“案例包装”，我们交付可复制的增长路径。</p>
          </div>
        </div>

        <div class="story-section">
          <div class="section-header">
            <h2 class="section-title">我们为何不同？</h2>
          </div>
          <div class="section-content">
            <p>因为拥有200W+宝妈私域生态、50W+KOC资源、3000W粉丝覆盖；</p>
            <p>因为拥有一套从内容到转化、从公域到私域、从投放到复购的完整心法。</p>
            <p>所以我们不只是“乙方”，我们更是品牌方的流量合伙人。</p>
            <p>因为我们相信：真正的价值，必须可衡量、可交付、可持续。</p>
            <p>所以我们签对赌、保ROI、承诺爆文率！！！</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们的核心理念 区域 -->
    <div class="hxln">
      <div class="hxln-container">
        <div class="hxln-title" id="hxln">我们的核心价值</div>
        <!-- <p style="text-align: center">越璋始终坚持以客户为中心的价值导向，致力于成为行业领先的数字化解决方案提供商</p> -->
        <div class="hxln-content">
          <div class="con">
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/about/hxln1.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">保投产</div>
                <div class="n-text">私域 & CID & UD 多渠道联动，确保每一分投入都带来回报</div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/about/hxln2.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">流量全域赋能</div>
                <div class="n-text">内容 & 聚光 双引擎驱动，利用爆款内容，赋能流量流转</div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="../../assets/images/about/hxln3.png" alt="">
              </div>
              <div class="text">
                <div class="xxl-text">数据模型构建</div>
                <div class="n-text">定制数据模型，让增长可视化</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 创始人介绍 区域 -->
    <div class="csrjs">
      <div class="csrjs-container">
        <div class="csrjs-title">创始人介绍</div>
        <!-- <p style="text-align: center">越璋的创立源于对行业深刻的洞察和改变现状的决心</p> -->
        <div class="csrjs-content">
          <div class="con">
            <div class="left">
              <img src="../../assets/images/关于我们-创始人照片.png" alt="">
            </div>
            <div class="right">
              <div class="right-con">
                <div class="csrxm">岳丹青</div>
                <div class="zw" style="color: #F20303;">创始人 & CEO</div>
                <div class="jy">作为甲方，我们打过亿级GMV；</div>
                <div class="jy">作为乙方，我们花过3亿+预算；</div>
                <div class="jy">作为丙方伙伴，我们落地5亿+平台项目执行；</div>
                <div class="jy">——所以，我们真正知道：增长怎么来，钱该怎么花，平台如何协同。</div>
                <div class="jy">我们希望有一种内容，它真实、有温暖、能承载“人”的声音，讲明白产品与用户之间的关系。</div>
                <div class="jy">我们也知道每一个品牌，都是一块未经打磨的“璋”。内里有光，只是藏在石中。</div>
                <div class="jy">我们不做“包装”，我们做“唤醒”。</div>
                <div class="jy">用内容凿开外壳，用数据雕琢形状，用流量点亮光泽。</div>
                <div class="jy">我们不是“帮你做内容”，我们是帮你把品牌，变成消费者愿意主动寻找、自发分享、长期信赖的那块宝玉</div>
                <div class="custom-line"></div>
                <div class="zz">
                  <div class="yjzz">越璋文化，以内容为刀，以流量为石，雕琢品牌之光</div>
                  <div class="yjzz">如果你也在寻找那个，能看懂你内里的光、并愿与你共同打磨的人——我们一直都在。</div>
                </div>
                <div class="yy">
                  <div class="yjyy">岳丹青</div>
                  <div class="yjyy">越璋文化创始人</div>
                </div>

                <!-- <div class="ms">
                  <div>2018-2024年聚焦在小红书达人赛道，深耕内容、达人公私域结合打法，助力品牌营销效果化，</div>
                  <div>累计服务超过2000个品牌</div>
                </div> -->
                <!-- <div class="sj">
                  <div class="jysj">
                    <div class="num">18年</div>
                    <div>行业经验</div>
                  </div>
                  <div class="khsj">
                    <div class="num">2000+</div>
                    <div>服务客户</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 发展历程 区域 -->
    <div class="fzlc">
      <div class="fzlc-container">
        <div class="fzlc-title" id="fzlc">发展历程</div>
        <p>从初创团队到行业领先者，每一步都凝聚着越璋人的智慧与汗水</p>
        <div class="fzlc-content">
          <a-timeline pending>
            <a-timeline-item v-for="(item, i) in fzlcList" :key="i">
              <div class="icon" slot="dot">{{ item.year }}</div>
              <div class="con">
                <div class="card">
                  <div class="item">
                    <div class="font-semibold">{{ item.title }}</div>
                    <div class="font-n">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
            </a-timeline-item>

            <a-timeline-item color="#e8e8e8"></a-timeline-item>
          </a-timeline>
        </div>
      </div>
    </div>

    <!-- 业务实力 区域 -->
    <div class="ywsl">
      <div class="ywsl-container">
        <div class="ywsl-title">越璋业务实力</div>
        <p style="text-align: center">以数据说话，用结果证明，越璋用从不停歇的内卷，成为众多企业的首选合作伙伴</p>
        <div class="ywsl-content">
          <div class="con">
            <div class="item">
              <div class="text">
                <div class="xxl-text">300%</div>
                <div class="n-text">单业务线年增长率</div>
                <div class="d-text">连续三年保持赛道迭代并高速增长态势</div>
              </div>
            </div>
            <div class="item">
              <div class="text">
                <div class="xxl-text">92%</div>
                <div class="n-text">客户复投率</div>
                <div class="d-text">超九成客户选择持续合作</div>
              </div>
            </div>
            <div class="item">
              <div class="text">
                <div class="xxl-text">20+</div>
                <div class="n-text">覆盖行业</div>
                <div class="d-text">服务领域横跨多个主流行业</div>
              </div>
            </div>
            <div class="item">
              <div class="text">
                <div class="xxl-text">99.9%</div>
                <div class="n-text">系统稳定性</div>
                <div class="d-text">保障客户业务连续稳定运行</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 区域 -->
    <div class="lxwm">
      <div class="lxwm-container">
        <div class="lxwm-title">联系我们</div>
        <p style="text-align: center">期待与您的合作，共创美好未来</p>
        <div class="lxwm-content">
          <div class="con">
            <div class="left">
              <!--              <img src="../../assets/images/公司地址图片.png" alt="">-->
            </div>
            <div class="right">
              <div class="right-con">
                <div class="top">联系信息</div>
                <div class="item">
                  <div class="icon"><img src="../../assets/images/about/lxr.png" alt=""></div>
                  <div class="desc">
                    <div class="title"> 联系人</div>
                    <div class="text"> 岳女士</div>
                  </div>
                </div>
                <div class="item">
                  <div class="icon"><img src="../../assets/images/about/lxdh.png" alt=""></div>
                  <div class="desc">
                    <div class="title"> 联系电话</div>
                    <div class="text"> +86 13666648636</div>
                  </div>
                </div>
                <div class="item">
                  <div class="icon"><img src="../../assets/images/about/dzyx.png" alt=""></div>
                  <div class="desc">
                    <div class="title"> 电子邮箱</div>
                    <div class="text">katherine@qixidata.com</div>
                  </div>
                </div>
                <div class="item">
                  <div class="icon"><img src="../../assets/images/about/gzsj.png" alt=""></div>
                  <div class="desc">
                    <div class="title">工作时间</div>
                    <div class="text">周一至周五 9:30 - 18:30</div>
                  </div>
                </div>
                <div class="item">
                  <div class="icon"><img src="../../assets/images/about/gsdz.png" alt=""></div>
                  <div class="desc">
                    <div class="title">公司地址</div>
                    <div class="text">浙江省杭州市余杭区仓前街道龙潭路16号3幢8层809室</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import eventBus from "@/utils/eventBus";

export default {
  components: {},
  data() {
    return {
      fzlcList: [
        {
          year: '2019',
          title: 'DMP外投业务开展',
          desc: '通过DMP外投，服务了20+以上的头部TP以及4A，当年为店铺精准引流UV超2000W，首年服务费规模超过5000W，产出GSV6000W+'
        },
        {
          year: '2020',
          title: '重仓小红书KOC,成为阿里健康小红书保ROI服务商',
          desc: '同年成为天猫母婴派样承接方。年度投放小红书KOC笔记120W篇。构建达人粉丝群和母婴群1W+左右。小红书投放规模突破2000W+。GSV达到5000W+'
        },
        { year: '2021', title: '成为腾讯云选供应商', desc: '年单一客户体量突破1000W。私域投放规模突破5000W+，GSV达到1.5亿+。同年引进RPA构筑自动化内容策略及投放一体流程。' },
        {
          year: '2022',
          title: '成为天猫国际营销投放保量服务商',
          desc: '双十一周期为天猫国际服务跨境商家35家/次，为当年天猫国际新商家服务体量最大的服务商之一。当年仅医药与保健项目营收突破1.5亿，GSV达到2.8亿+'
        },
        {
          year: '2023',
          title: '成为京东健康营销投放保量服务商',
          desc: '同年开始服务多家直客品牌，与7家上市企业的品牌有超千万的年投放金额。年营业额超过3.3亿。GSV达到5.5亿+'
        },
        { year: '2024', title: '聚焦小红书赛道', desc: '重仓小红书，开启CID，布局AI、GEO融合业务，新赛道突破1.8亿，GSV达到4.5亿+' },
        { year: '2025', title: '聚焦小红书赛道', desc: 'CID&UDS持续发力，仅小红书单渠道突破1亿+，GSV达到3.5亿+' },
      ]
    };
  },
  created() {
  },
  mounted() {
    // 1. 获取路由参数中的目标div id
    const targetId = this.$route.query.scrollTo;
    if (targetId) {
      this.$nextTick(() => {
        this.scrollToEl(targetId);
      });
    }

    // 监听App.vue触发的事件，执行scrollToEl
    this.scrollHandler = (elementId) => {
      this.scrollToEl(elementId);
    };
    eventBus.$on('scrollToPageEl', this.scrollHandler);
  },
  beforeDestroy() {
    // 销毁监听，避免内存泄漏（必须加）
    eventBus.$off('scrollToPageEl', this.scrollHandler);
  },
  methods: {
    scrollToEl(elementId) {
      const targetDiv = document.querySelector(`#${elementId}`);
      if (targetDiv) {
        // 方式B：平滑滚动（推荐，体验更好）
        targetDiv.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "center" // 对齐目标元素的顶部（可选：center/end）
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.el-dialog__body {
  background-color: #f9fafb;
}

.six {
  background-color: #F9FAFB;
  font-size: 15px;

  .about {
    margin: 0 auto;
    margin-top: 100px;
    width: 100%;

    height: 500px;
    background-color: #ffffff;
    background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
      /* 黑色遮罩，透明度0.5（0-1可调） */
      url(../../assets/images/关于我们大图.jpg) center center / cover no-repeat;
    /* 背景图片（保持原有设置） */
    background-size: cover;
    /* 图片充满容器，可能裁剪部分内容 */
    /* 或使用 background-size: contain; 图片完整显示，可能留空白 */
    background-repeat: no-repeat;
    /* 禁止图片重复 */
    background-position: center;
    /* 图片居中显示（可选） */
    position: relative;

    /* 开启相对定位，让箭头以它为基准 */
    // 向下箭头样式
    .scroll-down-arrow {
      position: absolute;
      left: 50%;
      bottom: 30px;
      /* 距离底部的距离，可调整 */
      transform: translateX(-50%);
      width: 15px;
      height: 15px;
      border: 2px solid #fff;
      border-left: none;
      border-top: none;
      transform: translateX(-50%) rotate(45deg);
      animation: bounce 1.5s infinite;
      /* 上下浮动动画 */
    }

    .hero-text-container {
      margin: 0 auto;
      text-align: center;
      padding-top: 100px;
      height: 40%;
      width: 59%;
      //display: flex;
      //-webkit-box-orient: vertical;
      //-ms-flex-direction: column;
      //flex-direction: column;
      //-webkit-box-align: center;
      //-ms-flex-align: center;
      //align-items: flex-start;
      //-webkit-box-pack: center;
      //-ms-flex-pack: center;
      //justify-content: center;

      h1 {
        width: 100%;
        font-size: xxx-large;
        font-weight: bold;
        color: #ffffff;
      }

      p,
      .desc {
        width: 100%;
        color: #f3f3f3;
        font-size: 16px;
      }
    }
  }

  .yz-story {
    width: 100%;
    padding: 60px 0;
    background-color: #fff;

    .yz-story-container {
      width: 70%;
      margin: 0 auto;

      .yz-story-header {
        text-align: center;
        margin-bottom: 50px;

        .title {
          font-size: 32px;
          font-weight: bold;
          color: #262626;
          margin-bottom: 8px;
        }

        .subtitle {
          color: #7e8690;
          font-size: 16px;
        }
      }

      .story-section {
        background-color: #f9f2f2;
        padding: 25px 30px;
        margin-bottom: 12px;
        position: relative;

        // 左侧红色竖线
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          background-color: #f20303;
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;

          .section-title {
            font-size: 25px;
            font-weight: bold;
            color: #262626;
            margin: 0;
          }
        }

        .section-content {
          color: #595959;
          line-height: 1.8;
          font-size: 17px;

          p {
            margin: 8px 0;
          }

          .highlight {
            color: #f20303;
            font-weight: bold;
          }
        }
      }
    }
  }

  .hxln {
    width: 100%;

    height: 540px;
    background-color: #ffffff;

    .hxln-container {
      width: 80%;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 0 auto;

      .hxln-title {
        text-align: center;
        padding: 40px 20px 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .hxln-content {
        margin-top: 60px;

        .con {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 60px;
          padding-bottom: 50px;

          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fdfdfe;
            border: 1px solid #f4f4f5;
            /* 可选：添加实体边框，与虚影搭配 */
            border-radius: 15px;
            box-shadow: 0 0 10px #ebecec;
            /* 核心属性 */
            height: 240px;
            text-align: center;
            padding: 30px 50px;

            .icon {
              img {
                width: 60px;
                height: 60px;
              }
            }

            .text {
              padding-top: 10px;

              .xxl-text {
                font-size: x-large;
                font-weight: bold;
                padding: 10px 0;
              }

              .n-text {}
            }


          }
        }

      }
    }

  }

  .csrjs {
    width: 100%;

    height: 650px;
    background-color: #F9F2F2;

    .csrjs-container {
      width: 80%;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 0 auto;

      .csrjs-title {
        text-align: center;
        padding: 40px 20px 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .csrjs-content {
        margin-top: 0px;

        .con {
          display: flex;
          gap: 60px;

          .left {
            width: 40%;
            text-align: right;

            img {
              width: 370px;
            }
          }

          .right {
            width: 60%;
            background-color: #F9F2F2;

            .right-con {
              margin-top: 0px;

              .custom-line {
                width: 80%; // 横线长度，可改100%占满容器/固定px值
                height: 2px; // 横线粗细，按需调整
                background-color: #E5E7EB; // 横线颜色，可替换为你需要的色值（比如品牌红#F20303）
                margin-top: 10px; // 上下外边距（控制与上下内容的间距）+ 水平居中，可按需调整
              }

              .csrxm {
                font-size: 20px;
                font-weight: bold;
              }

              .ms,
              .jy,

              .sj {
                margin-top: 5px;
              }

              .zw {
                color: #558bef;
              }

              .zz {
                text-align: right;
              }

              .yy {
                margin-top: 10px;
                text-align: right;
              }

              .sj {
                display: flex;
                gap: 20px;
                //justify-content: center;
                align-items: center;

                .jysj,
                .khsj {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                }

                .num {
                  font-size: xx-large;
                  font-weight: bold;
                  color: #2e71ed;
                }
              }

            }
          }
        }

      }
    }

  }

  .fzlc {
    width: 100%;

    height: 1038px;
    padding-top: 30px;
    background-color: #ffffff;

    .fzlc-container {
      width: 65%;
      //background-color: #ffffff;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 0 auto;

      p {
        text-align: center;
      }

      .fzlc-title {
        text-align: center;
        padding: 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .fzlc-content {
        margin-top: 55px;

        .ant-timeline {
          .ant-timeline-item {
            padding: 0 0 15px;

            .icon {
              width: 50px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-radius: 100%;
              background-color: #FFE4E6;
              color: #F20303;
              font-weight: bold;
            }

            .con {
              margin-left: 20px;
              font-size: 14px;
              color: #7e8690;

              h2 {
                font-weight: bold;
              }

              .card {
                margin: 10px;
                display: flex;
                gap: 20px;
                border: 1px solid #FFE4E6;
                border-radius: 10px;
                position: relative;

                /* 开启相对定位，让伪元素以它为基准 */
                // 新增：左上角红点
                &::before {
                  content: '';
                  position: absolute;
                  left: -6px;
                  /* 向左偏移，超出卡片边框 */
                  top: -6px;
                  /* 向上偏移，超出卡片边框 */
                  width: 12px;
                  /* 圆点直径 */
                  height: 12px;
                  /* 圆点直径 */
                  background-color: #F20303;
                  /* 你的品牌红色，和年份圆点颜色统一 */
                  border-radius: 50%;
                  z-index: 1;
                  /* 确保圆点显示在卡片最上层 */
                }

                .font-semibold {
                  color: #262626;
                  font-weight: bold;
                  font-size: large;
                }

                .item {
                  padding: 15px;
                  //border: 1px solid #e1e1e9; /* 可选：添加实体边框，与虚影搭配 */
                  background-color: #ffffff;
                  width: 100%;
                  border-radius: 10px;

                  .item-btn {
                    padding: 10px 0;

                    img {
                      width: 111px;
                      cursor: pointer;
                    }
                  }
                }
              }
            }
          }

          .timeline5 {
            padding: 0;
          }
        }
      }
    }

  }

  .ywsl {
    width: 100%;

    height: 443px;
    padding-top: 50px;
    // background: linear-gradient(to bottom right, #3260af, #059569);
    // //background: linear-gradient(to right, #3260af, #059569);
    // color: #FFFFFF;
    background-color: #ffffff;

    .ywsl-container {
      width: 80%;
      //background-color: #ffffff;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 0 auto;


      .ywsl-title {
        text-align: center;
        font-size: xx-large;
        font-weight: bold;
      }

      p {
        padding: 15px 0;
      }

      .ywsl-content {

        .con {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 50px;
          padding-bottom: 50px;

          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            //border: 1px solid #4078ab;
            border-radius: 15px;
            //background-color: #4078ab;
            background-color: #F9F2F2;
            /* 白色背景，透明度0.3（半透明） */
            //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
            height: 200px;
            text-align: center;

            .icon {
              img {
                width: 70px;
                height: 70px;
              }
            }

            .text {
              padding-top: 24px;
              height: 100%;

              .xxl-text {
                font-size: xxx-large;
                font-weight: bold;
                color: #F20303;
              }

              .n-text {
                padding: 10px;
                font-size: 17px;
                color: #F20303;
              }

              .d-text {
                color: #F20303;
              }
            }


          }
        }

      }
    }

  }

  .lxwm {
    width: 100%;
    height: 697px;
    background-color: #F9F2F2;

    .lxwm-container {
      width: 80%;
      //border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
      //border-radius: 15px;
      //box-shadow: 0 0 10px #ebecec; /* 核心属性 */
      margin: 0 auto;

      .lxwm-title {
        text-align: center;
        padding: 40px 20px 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .lxwm-content {
        margin-top: 50px;

        .con {
          display: flex;
          height: 500px;

          .left {
            width: 50%;
            height: 100%;
            text-align: right;

            background-image: url("../../assets/images/公司地址图片.png");
            background-repeat: no-repeat;
            /* 禁止重复 */
            background-position: center;
            /* 居中显示 */
            background-size: contain;
            /* 完整显示图片，贴合div比例，无拉伸（推荐） */

            //img {
            //  width: 100%;
            //  height: 100%;
            //}
          }

          .right {
            width: 50%;
            display: flex;
            align-items: center;
            background-color: #FFFFFF;

            .right-con {
              .top {
                padding: 15px 20px;
                font-size: 21px;
                font-weight: bold;
              }

              .item {
                padding: 10px 20px;
                display: flex;
                gap: 10px;
                font-size: 17px;

                img {
                  width: 50px;
                  height: 50px;
                }

                .desc {
                  .title {
                    font-weight: bold;
                    font-size: 17px;
                  }
                }
              }
            }
          }
        }

      }
    }

  }
}
</style>